import { render, staticRenderFns } from "./PremiumTransformationDataTable.vue?vue&type=template&id=4dcd433e&scoped=true"
import script from "./PremiumTransformationDataTable.vue?vue&type=script&lang=js"
export * from "./PremiumTransformationDataTable.vue?vue&type=script&lang=js"
import style0 from "./PremiumTransformationDataTable.vue?vue&type=style&index=0&id=4dcd433e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd433e",
  null
  
)

export default component.exports